import Company from './company'

const COMPANY = 'company'

export const companyStorage = Company(COMPANY)
